<template>
  <div class="body-wrapper">
    <Header :title="'Dashboard'" />
    <div class="wrapper">
      <StatOptions
        :selectedRange="selectedRange"
        @changeDate="changeDate"
       />
      <div class="row-label row1-label">USER STATS</div>
      <div class="row1-content">
        <widget
          :title="'ACTIVE NOW'"
          :value="activeNow" />
        <widget
          :title="'NEW USERS'"
          :date-filtered="true"
          :value="newUsers" />
        <widget
          :title="'TOTAL USERS'"
          :value="totalUsers" />
        <widget
          :title="'TOTAL PRO USERS'"
          :value="totalProUsers" />
        <widget
          :title="'RECENT PRO RATIO'"
          :value="recentProRatio + '%'" />
        <widget
          :title="'TOTAL WORKOUTS'"
          :value="totalWorkouts" />
      </div>
      <div class="row-label row3-label">USAGE</div>
      <div class="row3-content">
        <widget
          :title="'UNIQUE SESSIONS'"
          :date-filtered="true"
          :value="uniqueSessions" />
        <widget
          :title="'ALL SESSIONS'"
          :date-filtered="true"
          :value="allSessions" />
        <widget
          :title="'WORKOUTS'"
          :date-filtered="true"
          :value="workouts" />
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/header/Header";
import StatOptions from "@/components/stats/StatOptions";
import Widget from "@/components/dashboard/Widget";

export default {
  name: 'Dashboard',

  components: {
    Header,
    StatOptions,
    Widget
  },

  data() {
    return {
      selectedRange: 'TD'
    }
  },

  async mounted() {
    this.$store.dispatch('dashboard/loadDateFilterStats', this.selectedRange);
    this.$store.dispatch('dashboard/loadStaticStats');
  },

  methods: {
    changeDate(value) {
      this.selectedRange = value;
      this.$store.dispatch('dashboard/loadDateFilterStats', this.selectedRange);
    }
  },

  computed: {
    activeNow() {
      return this.$store.state.dashboard.activeNow;
    },

    totalUsers() {
      return this.$store.state.dashboard.totalUsers;
    },

    totalProUsers() {
      return this.$store.state.dashboard.totalProUsers;
    },

    recentProRatio() {
      return this.$store.state.dashboard.recentProRatio;
    },

    newUsers() {
      return this.$store.state.dashboard.newUsers;
    },

    allSessions() {
      return this.$store.state.dashboard.sessions;
    },

    totalWorkouts() {
      return this.$store.state.dashboard.totalWorkouts;
    },

    workouts() {
      return this.$store.state.dashboard.currentWorkouts;
    },

    uniqueSessions() {
      return this.$store.state.dashboard.uniqueSessions;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";

.wrapper {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: $spacing-base;
  grid-auto-rows: minmax(30px, auto);
}
.stats-row {
  grid-column: 2;
  grid-row: 1;
  padding-top: $spacing-base;
}
.row-label {
  writing-mode: vertical-lr;
  -webkit-transform: rotate(-180deg);
  transform: rotate(-180deg);
  color: $sec3;
  font-weight: bold;
  padding-right: $spacing-base;
  text-align: right;
}
.row1-label {
  grid-column: 1;
  grid-row: 2;
}
.row1-content {
  grid-column: 2;
  grid-row: 2;
  display: flex;
  gap: $spacing-base;
}
.row2-label {
  grid-column: 1;
  grid-row: 3;
}
.row2-content {
  grid-column: 2;
  grid-row: 3;
}
.row3-label {
  grid-column: 1;
  grid-row: 4;
}
.row3-content {
  grid-column: 2;
  grid-row: 4;
  display: flex;
  gap: $spacing-base;
}
</style>
